export default "__VITE_ASSET__OD$3$N_V__"